module.exports = __webpack_public_path__ + "static/media/stille.fa1d4344.m4a";